import React from 'react';

import './ProductInstanceSelector.scss';

type CurrentProductInstance = {
    name: string;
    description: string;
    logo?: string | null;
    logoAlt?: string | null;
};

type ProductInstanceSelectorProps = {
    product: CurrentProductInstance;
};

export default class ProductInstanceSelector extends React.Component<ProductInstanceSelectorProps> {
    render() {
        const { product } = this.props;
        const distributionLogo = product.logo ?? null;

        return (
            <div className="productInstanceSelector">
                <div className="currentInstance">
                    <div className="heading d-flex flex-row flex-nowrap">
                        <div className="headingName">
                            {distributionLogo && (
                                <span className="distributionLogo">
                                    <img src={distributionLogo} alt={product.logoAlt ?? ''} />
                                </span>
                            )}
                            {product.name}
                        </div>
                    </div>
                    <div className="description">{product.description}</div>
                </div>
            </div>
        );
    }
}
